

export const version = "V 11.0.15";
export const versionDate = "June 11, 2026 6:12 AM EDT";
export const versionNotes = "S1 Search now updates the navigation label as Regular Search";

export const getScoutReports = async (playerID, user) => {
    const API_ENDPOINT = "https://www.fbxchange.com/ReactPHP/scoutreports.php"; // unchanged
    const res = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            scriptName: "getReports",
            ID: playerID,
            scout: user.scout,
            team: user.team || "",
        }),
    });
    const resp = await res.json();
    return resp;
};

export const getOneScoutReport = (reportID, user) => {
    return `scoutReport_${reportID}`;
}
